import { topicsData } from '@/mocks/home';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function TopicsSection() {
  const ref = useScrollReveal();
  return (
    <section id="topics" ref={ref} className="reveal-section py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            大家都在关注的影视话题，热度实时更新
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic, idx) => (
            <div
              key={idx}
              className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 hover:border-accent-300/60 hover:bg-accent-50 transition-all duration-300 cursor-pointer"
            >
              {topic.hot && (
                <i className="ri-fire-fill text-accent-500 text-sm"></i>
              )}
              <span className="text-sm font-medium text-foreground-800">{topic.name}</span>
              <span className="text-xs text-foreground-500">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}